// extracted by mini-css-extract-plugin
export default {"customField":"CustomValidationField_customField__E9rky","checkItem":"CustomValidationField_checkItem__rF7RR"};